import React from 'react';
const STROKE = '#5e2a56';
const LINE_OPACITY = 0.06;

// Long, quiet construction geometry spanning the upper hero — lines only.
const horizontals = [{
  y: 96,
  dash: '2 6'
}, {
  y: 250,
  dash: '24 6 3 6'
}, {
  y: 430,
  dash: '2 6'
}, {
  y: 610,
  dash: '24 6 3 6'
}];
const verticals = [{
  x: 112,
  dash: '2 6'
}, {
  x: 336,
  dash: '24 6 3 6'
}, {
  x: 1024,
  dash: '24 6 3 6'
}, {
  x: 1248,
  dash: '2 6'
}];
const sweeps = ['M-40 640 A760 760 0 0 1 1400 640', 'M120 680 A600 600 0 0 1 1240 680', 'M-60 40 A420 420 0 0 1 300 680', 'M1420 40 A420 420 0 0 0 1060 680'];
const rays = ['M0 0 L560 680', 'M1360 0 L800 680', 'M0 360 L680 250 L1360 360'];
function ticks(y: number, from: number, to: number, step: number) {
  const out: string[] = [];
  for (let x = from; x <= to; x += step) out.push(`M${x} ${y - 3}V${y + 3}`);
  return out.join('');
}
export function HeroBlueprint() {
  return <svg className="pointer-events-none absolute inset-0 hidden h-full w-full lg:block" viewBox="0 0 1360 1240" preserveAspectRatio="xMidYMin slice" aria-hidden="true" data-id="element-300" data-mp="2ojbqhepf2osy">
      <defs data-id="element-301" data-mp="36j8zjr9y0dpz">
        <pattern id="bp-hatch" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(45)" data-id="element-302" data-mp="36jigkpd0fajj">
          <line x1="0" y1="0" x2="0" y2="7" stroke={STROKE} strokeOpacity="0.09" strokeWidth="1" data-id="element-303" data-mp="3kfm4y217coo3" />
        </pattern>
        <marker id="bp-arrow" viewBox="0 0 8 8" refX="7" refY="4" markerWidth="7" markerHeight="7" orient="auto-start-reverse" data-id="element-304" data-mp="3fkyngn4m8uj0">
          <path d="M0 1L7 4L0 7" fill="none" stroke={STROKE} strokeOpacity="0.28" strokeWidth="1" data-id="element-305" data-mp="3phbgdisc74cp" />
        </marker>
      </defs>

      {/* ── Upper area: uniform construction lines ── */}
      <g fill="none" stroke={STROKE} strokeOpacity={LINE_OPACITY} strokeWidth="1" data-id="element-306" data-mp="31gylndtwjfn">
        {horizontals.map(({
        y,
        dash
      }) => <line key={`h${y}`} x1="0" y1={y} x2="1360" y2={y} strokeDasharray={dash} data-id="element-307" data-mp="h21hsknnoh9o" />)}
        {verticals.map(({
        x,
        dash
      }) => <line key={`v${x}`} x1={x} y1="0" x2={x} y2="700" strokeDasharray={dash} data-id="element-308" data-mp="c02gdgbh7ufd" />)}
        {sweeps.map(d => <path key={d} d={d} data-id="element-309" data-mp="39v74jq2ctsgb" />)}
        {rays.map(d => <path key={d} d={d} strokeDasharray="1 5" data-id="element-310" data-mp="39tdue0sj8q3k" />)}
        <path d={ticks(96, 16, 1344, 32)} data-id="element-311" data-mp="3etrwz3bd77u7" />
        <path d={ticks(610, 16, 1344, 32)} data-id="element-312" data-mp="3esqmazy9gnd0" />
      </g>

      <g fill="none" stroke={STROKE} strokeWidth="1" opacity="0.5" data-id="element-313" data-mp="3jm1scyv9103v">
        <line x1="40" y1="980" x2="1320" y2="980" strokeOpacity="0.05" strokeDasharray="3 7" data-id="element-314" data-mp="3okwby311isp1" />

        {/* ── Left bottom: stepped shaft, half section ── */}
        <g strokeOpacity="0.13" data-id="element-315" data-mp="3tlk9l7jry7s8">
          <path d="M60 880 H120 V860 H210 V850 H262 V870 H300 V880" data-id="element-316" data-mp="1f5bxljq5fp4" />
          <path d="M60 880 V940 H120 V960 H210 V970 H262 V950 H300 V880" strokeDasharray="5 4" strokeOpacity="0.7" data-id="element-317" data-mp="1du85lqa47y0" />
          <rect x="120" y="860" width="90" height="20" fill="url(#bp-hatch)" stroke="none" data-id="element-318" data-mp="2371pf0pgczmj" />
          <rect x="210" y="850" width="52" height="30" fill="url(#bp-hatch)" stroke="none" data-id="element-319" data-mp="2864swgpsaxse" />
          <line x1="226" y1="850" x2="226" y2="880" data-id="element-320" data-mp="287xz5uwhjfzv" />
          <line x1="246" y1="850" x2="246" y2="880" data-id="element-321" data-mp="20ndoq9lx4nne" />
        </g>
        <line x1="40" y1="910" x2="320" y2="910" strokeOpacity="0.1" strokeDasharray="18 4 3 4" data-id="element-322" data-mp="1vw5b11dk2g4f" />
        <line x1="60" y1="1010" x2="300" y2="1010" strokeOpacity="0.2" markerStart="url(#bp-arrow)" markerEnd="url(#bp-arrow)" data-id="element-323" data-mp="1qwiyyv9gr5x7" />
        <line x1="60" y1="944" x2="60" y2="1018" strokeOpacity="0.1" data-id="element-324" data-mp="1lyqxb9j0o5ft" />
        <line x1="300" y1="884" x2="300" y2="1018" strokeOpacity="0.1" data-id="element-325" data-mp="2jl7wkkbb8t47" />

        {/* ── Right bottom: isometric angle bracket ── */}
        <g strokeOpacity="0.13" strokeLinejoin="round" data-id="element-326" data-mp="2enoef9bhrw6z">
          <path d="M1090 900 L1190 842 L1290 900 L1190 958 Z" data-id="element-327" data-mp="29n0dnvxgo0zk" />
          <path d="M1090 900 V916 L1190 974 L1290 916 V900" data-id="element-328" data-mp="29lh04d36w41h" />
          <path d="M1190 958 V974" data-id="element-329" data-mp="25kn9hbyd4b4w" />
          <path d="M1090 900 V780 L1112 767 V887" data-id="element-330" data-mp="25lf34h8efysj" />
          <path d="M1112 767 L1212 709 L1190 722 L1090 780" data-id="element-331" data-mp="y8dfscy25ozh" />
          <path d="M1212 709 V829" strokeDasharray="4 4" strokeOpacity="0.6" data-id="element-332" data-mp="y5sblhaaewyk" />
          <ellipse cx="1222" cy="906" rx="14" ry="8" data-id="element-333" data-mp="u58f8fxjfxdh" />
          <ellipse cx="1158" cy="874" rx="14" ry="8" data-id="element-334" data-mp="2i2y2axn5cpph" />
          <ellipse cx="1101" cy="824" rx="5" ry="12" data-id="element-335" data-mp="2i14uhf0srzfw" />
        </g>
        <path d="M1290 916 L1316 930 M1190 974 L1216 988 M1300 922 L1206 976" strokeOpacity="0.12" data-id="element-336" data-mp="2mupwdi5ihdkd" />
      </g>

      <g fill={STROKE} fillOpacity="0.13" fontFamily="IBM Plex Mono, ui-monospace, monospace" fontSize="11" letterSpacing="0.06em" data-id="element-337" data-mp="286mq07nk3zv1">
        <text x="180" y="1002" textAnchor="middle" data-id="element-338" data-mp="30uqwgvdycgys">L = 240 ±0,1</text>
        <text x="60" y="842" data-id="element-339" data-mp="35sjzxgnvewvd">A–A</text>
        <text x="1270" y="1000" textAnchor="end" data-id="element-340" data-mp="35rhdbkxkzgl9">t = 6 · S235JR</text>
        <text x="1320" y="1206" textAnchor="end" fillOpacity="0.6" data-id="element-341" data-mp="2rtkesizkh03y">KW · M 1:2</text>
        <text x="40" y="1206" fillOpacity="0.6" data-id="element-342" data-mp="2vuclb4h20qwj">DIN ISO 2768-mK</text>
      </g>
    </svg>;
}